import { render, staticRenderFns } from "./base-attr.vue?vue&type=template&id=18ae66ea&scoped=true"
import script from "./base-attr.vue?vue&type=script&lang=js"
export * from "./base-attr.vue?vue&type=script&lang=js"
import style0 from "./base-attr.vue?vue&type=style&index=0&id=18ae66ea&prod&lang=scss&scoped=true"
import style1 from "./base-attr.vue?vue&type=style&index=1&id=18ae66ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae66ea",
  null
  
)

export default component.exports